import SeoPage from "../components/SeoPage";

export default function Cloud() {
  return (
    <SeoPage
      title="Cloud Solutions Company | Arviko"
      description="Cloud infrastructure and scalable deployment solutions."
      heading="Cloud Solutions"
    >
      <p>
        We provide cloud-based solutions for scalable applications.
      </p>
    </SeoPage>
  );
}